export enum MarkupMethod {
    Markup = 0,
    Coverage = 1
}

(MarkupMethod as any).__typeName = 'MarkupMethod';
